/*global VeloxGridAndFormController, VeloxFormController*/

var newsController = new VeloxGridAndFormController("news", {
    grid : {
        directory: "views/news",
        name: "newsGrid"
    },
    form : {
        directory: "views/news",
        name: "newsForm"
    }
});

module.exports = newsController ;